function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.882,10.324c0.896,0.512,0.896,1.349,0,1.862l-9.874,5.641c-0.896,0.511-1.629,0.087-1.629-0.944V5.627 c0-1.032,0.733-1.458,1.629-0.945L20.882,10.324z M28.138,20.635H1.876V1.876h26.262V20.635z M25.323,26.262H9.379v0.938 c0,0.519-0.42,0.938-0.938,0.938c-0.519,0-0.938-0.419-0.938-0.938v-0.938H4.689c-0.518,0-0.938-0.42-0.938-0.938 c0-0.519,0.42-0.938,0.938-0.938h2.813v-0.938c0-0.518,0.42-0.938,0.938-0.938c0.518,0,0.938,0.42,0.938,0.938v0.938h15.944 c0.519,0,0.938,0.42,0.938,0.938C26.262,25.842,25.842,26.262,25.323,26.262z M28.138,0H1.876C0.84,0,0,0.84,0,1.876v26.261 c0,1.037,0.84,1.877,1.876,1.877h26.262c1.036,0,1.875-0.84,1.875-1.877V1.876C30.013,0.84,29.174,0,28.138,0z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.013 30.014",
    enableBackground: "new 0 0 30.013 30.014",
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/video.58b0fd2b.svg";
export { SvgComponent as ReactComponent };